module.exports = __webpack_public_path__ + "static/img/bi.06f36479.svg";